import { render, staticRenderFns } from "./virtual-gift-list.vue?vue&type=template&id=24caf163&scoped=true"
import script from "./virtual-gift-list.vue?vue&type=script&lang=js"
export * from "./virtual-gift-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24caf163",
  null
  
)

export default component.exports